import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import PrivacyContent from '../Components/Privacy/PrivacyContent';
import PrivacyNav from '../Components/Privacy/PrivacyNav';
import $ from 'jquery';

export default function Privacy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Privacy-policy',
    title: 'Privacy Policy',
  });

    const downloadSummary = () => {
      const element = document.getElementById('printer');
      if (!element) return;
      element.classList.add('pdf-mode');
        const opt = {
          margin: [20, 40, 40, 20],
          filename: 'privacy-policy.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
          pagebreak: {
            mode: ['avoid-all', 'css', 'legacy'],
          },
        };
        html2pdf().set(opt).from(element).save().then(() => {
          element.classList.remove('pdf-mode');
        });
      }

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Privacy Policy</title>
        <meta
          name="description"
          content="This Privacy Policy explains our practices regarding the use of personal data collected and processed through our website, contacts with third parties and the provision of services."
        />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Privacy-policy" />
        <meta property="og:title" content="DISGENET: Privacy Policy" />
        <meta
          property="og:description"
          content="MedBioinformatic Solutions SL (“MedBio”, the “Company”, or “we/us”), is committed to protecting the privacy of all users (“You/r”) of our website and services."
        />
         </Helmet>
      <CommonHeader />

      <section>
        <link rel="canonical" href="/Privacy-policy" />
            <div className="container txt-contenido mr-20 mt-2 text-right">
              <button
                className="btn bg-light rounded-circle fa fa-print"
                onClick={downloadSummary}
              ></button>
            </div>
        <div className="container txt-contenido" id="printer">
          <h2 className="mt-8 bg-transparent">Privacy Policy</h2>
          <div className="privacy-nav">
          <PrivacyNav />
          </div>
          <PrivacyContent />
        </div>
      </section>
    </React.Fragment>
  );
}
